var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3259_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9689 11.5337L25.6297 0.536133H23.3407L14.9485 10.0832L8.25054 0.536133H0.523438L10.6543 14.9742L0.523438 26.5058H2.81242L11.6694 16.4215L18.7444 26.5058H26.4715L15.9689 11.5337ZM12.8328 15.1009L11.8048 13.6623L3.63787 2.2261H7.15423L13.7471 11.459L14.7708 12.8976L23.3396 24.8983H19.8233L12.8328 15.1009Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3259_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6ee61d8bdc728859af72a5f8e8632c25.svg";
export { ForwardRef as ReactComponent };